module.exports = __webpack_public_path__ + "static/media/400158_02.7f55988e.png";